import { useState } from 'react'

import { TableFooter } from 'components'
import { ViewFileIcon } from 'components/Icons'
import { COLORS, FORMAT } from 'utils'

import {
  TableCellStyled,
  TableRowStyled,
  TableBodyStyled,
  TableStyled,
  TableHeadStyled,
  TableContainerStyled
} from './ConsultDocsTable.styles'
import moment from 'moment'

interface ITableConsultDocs {
  attachDocsList: any[]
  handleViewDocument: (id: number) => void
}
export const ConsultDocsTable = ({
  attachDocsList,
  handleViewDocument
}: ITableConsultDocs) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(15)

  const handleChangePage = (newPage: number) => setPage(newPage)

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  function compareDateCompetencia(a, b) {
    const competenciaA = a.split('/')
    const competenciaB = b.split('/')

    if (competenciaA[0] >= competenciaB[0]) {
      if (competenciaA[1] >= competenciaB[1]) {
        return 0
      } else {
        return -1
      }
    } else {
      if (competenciaA[1] > competenciaB[1]) {
        return 0
      } else {
        return -1
      }
    }
  }
  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled minwidth="10em" align="left">
                Arquivo
              </TableCellStyled>
              <TableCellStyled align="left">Tipo Documento</TableCellStyled>
              <TableCellStyled align="left">Competência</TableCellStyled>
              <TableCellStyled align="left">Tipo</TableCellStyled>
              <TableCellStyled align="left">Início Vigência</TableCellStyled>
              <TableCellStyled align="left">Fim Vigência</TableCellStyled>
              <TableCellStyled align="left">Data Anexo</TableCellStyled>
              <TableCellStyled align="left">Matricula</TableCellStyled>
              <TableCellStyled align="left">Vencido</TableCellStyled>
              <TableCellStyled align="left">Ação</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {(rowsPerPage > 0
              ? attachDocsList?.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : attachDocsList
            )
              ?.sort((a, b) =>
                compareDateCompetencia(
                  FORMAT.competencia(a.nuAnoMesCompetencia),
                  FORMAT.competencia(b.nuAnoMesCompetencia)
                )
              )
              .map((row, index) => (
                <TableRowStyled
                  backgroundColor={
                    !(row.cdGedExternalId > 0) ? COLORS.pink : null
                  }
                  key={`${index}-${row?.cdGedExternalId}-row`}
                >
                  <TableCellStyled align="left">
                    {row?.txFileName || '---------'}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {row?.txTipoPendencia}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {FORMAT.competencia(String(row?.nuAnoMesCompetencia))}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {row?.txTipo === 'Convencao'
                      ? 'Convenção'
                      : row?.txTipo || '---------'}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {FORMAT.formatDDMMYYYY(row?.dtVigenciaInicio) ||
                      '--------------'}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {FORMAT.formatDDMMYYYY(row?.dtVigenciaFim) ||
                      '--------------'}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {FORMAT.formatDDMMYYYY(row?.dtAnexo) || '--------------'}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {row?.usuarioMatricula}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {row?.flVencido ? 'Sim' : 'Não'}
                  </TableCellStyled>
                  <TableCellStyled align="center" padding="checkbox">
                    <ViewFileIcon
                      onClick={() => handleViewDocument(row.cdGedExternalId)}
                      cursor="pointer"
                      disabled={!(row.cdGedExternalId > 0)}
                    />
                  </TableCellStyled>
                </TableRowStyled>
              ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={attachDocsList}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        typeFooter="offline"
      />
    </>
  )
}
